import styled from 'styled-components'

export const IndicatorInfoStyle = styled.div`
  height: 100px;
  width: 200px;
  border: 1px solid pink;
  border-radius: 4px;
`
